import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

import SimpleSection from "../components/SimpleSection";
import SearchField from "../components/SearchField";
import AboutLayout from "../layouts/AboutLayout";
import { FilterContext } from "contextos/FilterContext";

export default function NotFoundScreen() {
  const [urlParams, setUrlParams] = useState({ verbatim: false, query: "" });
  // maneja el formulario
  const submitForm = (elements) => {
    const params = Array.from(elements);
    if (urlParams.verbatim) {
      window.location.href = `/search/?keywords=${params[0].value}&verbatim=1`;
    } else {
      window.location.href = `/search/?keywords=${params[0].value}`;
    }
  };
  // maneja el formulario
  const handleSearchBarSubmit = (e) => {
    e.preventDefault();
    const forms = document.getElementsByName("searchFormNotFoud");
    submitForm(forms[0].elements);
  };

  return (
    <AboutLayout
      title="Busqueda centralizada"
      subtitle={"subtitle"}
      notFoud={true}
    >
      <Container>
        <SimpleSection className="c-notfound-cirma">
          <Row>
            <FilterContext.Provider value={{ setUrlParams: setUrlParams }}>
              <Col sm={12}>
                <div className="c-notfound">
                  <h2 className="c-cirma-title">
                    Parece que esta página no existe.
                  </h2>
                  <h3 className="c-cirma-subtitle">
                    Parece que el enlace que apuntaba aquí no sirve. ¿Quieres
                    probar con una búsqueda?
                  </h3>
                  <div className="c-searchfiel">
                    <form
                      action={``}
                      onSubmit={handleSearchBarSubmit}
                      name="searchFormNotFoud"
                      id="btnFulltext"
                    >
                      <SearchField />
                    </form>
                  </div>
                </div>
              </Col>
            </FilterContext.Provider>
          </Row>
        </SimpleSection>
      </Container>
    </AboutLayout>
    // <div className='c-main-wrapper'>
    // 	<TopMenu background='white' />
    // </div>
  );
}
